import React, { FC, useCallback } from 'react';

import classNames from 'classnames';

import './Checkbox.scss';

type Props = {
    /**
     * Indicates whether the checkbox is checked or not.
     */
    readonly checked: boolean;

    /**
     * Indicates whether the checkbox is disabled or not.
     */
    readonly disabled?: boolean;

    /**
     * The label.
     */
    readonly label: string;

    /**
     * Callback when checkbox has been clicked.
     */
    readonly onChange?: (newValue: boolean) => void;
};

export const Checkbox: FC<Props> = ({ checked, disabled = false, label, onChange }) => {
    const onClick = useCallback(() => {
        if (!disabled && onChange) {
            onChange(!checked);
        }
    }, [disabled, onChange, checked]);

    return (
        <div className={classNames('checkbox', checked && 'checked')} onClick={onClick}>
            <div className={classNames('wrapper', disabled && 'disabled')}>
                {checked ? <i className="material-icons">check</i> : null}
            </div>
            <span>{label}</span>
        </div>
    );
};
